import styled, { css } from 'styled-components';
import { Icon } from '@bechtel/gds';

export interface CrewProgressTreeItemContainerStyledProps {
  depth: number;
}

function getPersonaGridCoumns({ depth }: CrewProgressTreeItemContainerStyledProps) {
  switch (depth) {
    case 1:
      return css`
        grid-template-columns: 200px 1fr 1fr 1fr;
      `;
    case 3:
      return css`
        grid-template-columns: 164px 1fr 1fr 1fr;
      `;
    case 5:
      return css`
        grid-template-columns: 128px 1fr 1fr 1fr;
      `;
    default:
      return css`
        grid-template-columns: calc(50% - 10px) 1fr 1fr 1fr;
      `;
  }
}
export const CrewProgressTreeItemContainerStyled = styled.div`
  position: relative;
  display: grid;
  align-items: center;
  justify-items: center;
  ${getPersonaGridCoumns}
`;

export const CrewProgressTreeItemPersonaStyled = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: grid;
    justify-self: left;
    grid-template-columns: ${theme.spacings[600]} auto;
  `}
`;

export const ExpandCollapseIconStyled = styled(Icon)`
  ${({ theme }) => css`
    height: ${theme.spacings[700]};
    width: ${theme.spacings[700]};
    padding-right: ${theme.spacings[400]};
    align-items: top;
    justify-content: center;
    color: ${theme.colors.blue[800]};
    cursor: pointer;
  `}
`;

export const ExpandedItemBorderStyled = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.grey[300]};
  top: ${({ theme }) => theme.spacings[800]};
  bottom: 0;
  width: 1px;
  left: 10px;
  z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
`;
